/** @format */

import React, { useEffect, useState } from "react";
import Select from "react-select";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { updateCoordinate } from "../../../../store/reducers/pdfeditor/pdfCoordinatesSlice.js";
import { selectVariable } from "../../../../store/reducers/pdfeditor/toolsModificationSlice.js";
import FontSize from "../../Pdf-Utils/Tools/FontSize.js";
import FontSizeHover from "../../Pdf-Utils/Tools/FontSizeHover/index.js";
import FontSpacingHover from "../FontSpacingHover/index.js";
import ToolBar from "../Toolbar/index.js";
// import { display } from "html2canvas/dist/types/css/property-descriptors/display.js";
const SelectField = ({
  items,
  scale,
  handleSelectBox,
  position,
  setDragBoxDetails,
  setSelectedVariable,
  settedFontSize,
  settedFontSpace,
  settedBoxHeight,
  settedBoxWidth,
  setSpecialField,
  multiField,
  setMultiField,
  setSelectedBoxId
}) => {
  const { options } = useSelector((state) => state.selectOptions);
  const { currVariable } = useSelector((state) => state.toolsModification);

  const { fontSize, fontFamily, fontSpace } = useSelector(
    (state) => state.toolsModification
  );
  const [subSelectData, setSubSelectData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedDataType, setSelectedDataType] = useState("");
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);

  const [showFontSizeHover, setShowFontSizeHover] = useState(false);
  const [showFontSpaceHover, setShowFontSpaceHover] = useState(false);

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      margin: "0px", // Apply -7px margin to the dropdown box
    }),
  };
  
  const selectStyle = {
    right: -110,
    zIndex: 11,
    backgroundColor: "transparent",
    padding: "0px",
    cursor: `${"pointer"}`,
    position: "absolute",
    left: `${items["y-coordinate"]< 40 ? items["x-coordinate"] * scale + 50 : items["x-coordinate"] * scale + 2}px`,
    top: `${items["y-coordinate"]< 40 ? items["y-coordinate"] * scale + 20 : items["y-coordinate"] * scale - 39}px`,
    borderRadius: "1px",
    width: "150px",
    height: "4px",
    fontFamily: `sans-serif`,
  };
  const Style = {
    right: -110,
    zIndex: 3,
    backgroundColor: "transparent",
    padding: "0px",
    cursor: `${"pointer"}`,
    position: "absolute",
    left: `${items["x-coordinate"] * scale + 153}px`,
    top: `${items["y-coordinate"] * scale - 39}px`,
    borderRadius: "1px",
    width: "150px",
    height: "4px",
    fontFamily: `sans-serif`,
  };
  const StyleFontBox = {
    right: -110,
    zIndex: 11,
    backgroundColor: "transparent",
    padding: "0px",
    cursor: `${"pointer"}`,
    position: "absolute",
    left: `${items["y-coordinate"]< 40 ? items["x-coordinate"] * scale : items["x-coordinate"] * scale + 2}px`,
    top: `${items["y-coordinate"]< 40 ? items["y-coordinate"] * scale + 20 : items["y-coordinate"] * scale - 76}px`,
    borderRadius: "1px",
    width: "150px",
    height: "4px",
    fontFamily: `sans-serif`,
  };

  let id = items?.id;
  let splitData = items?.value?.split(".")[1];

  const handleSelectOnChange = (selectOption) => {
    setMenuOpen(false);
    if (selectOption?.value?.values?.length > 0) {
      setMultiField(true);
    }
    let data_type = selectOption?.value?.data_type;
    setSelectedDataType(data_type);
    setSelectedVariable(selectOption?.label);
    let value = selectOption?.value?.variableName;
    if (data_type === "text") {
      let newValue = {
        value,
        data_type: "text",
        fontSize,
        fontFamily,
        fontSpace,
      };
      dispatch(updateCoordinate({ id, newValue }));
      dispatch(
        selectVariable({
          ...items,
          // variable: id,
          variableName: value,
          ...newValue,
        })
      );
    } else if (
      data_type === "select" ||
      data_type === "multi_signers" ||
      data_type === "digital_stamp"
    ) {
      setSelectedData(value);
      let values = selectOption?.value?.values;
      let newValue = {
        value,
        data_type: "text",
      };
      dispatch(
        selectVariable({
          ...items,
          variableName: value,
          fontSize: 10,
          fontFamily: "sans-serif",
          variable: id,
          data_type: "text",
        })
      );
      dispatch(updateCoordinate({ id, newValue }));
      let data =
        values?.length > 0 &&
        values?.map((item) => ({ value: item, label: item }));
      setSubSelectData(data);
    } else {
      let newValue = {
        value,
        data_type,
      };
      dispatch(
        selectVariable({
          ...items,
          variableName: value,
          // variable: id,
          data_type: data_type,
        })
      );
      dispatch(updateCoordinate({ id, newValue }));
    }
  };

  const handleChangeSubSelect = (selectOption) => {
    if (multiField) {
      setMultiField(false);
    }
    let newValue = {
      value: selectedData + "." + selectOption?.value,
      data_type:
        selectedDataType === "multi_signers" ||
        selectedDataType === "digital_stamp"
          ? selectedDataType
          : "image",
    };
    dispatch(
      selectVariable({
        ...items,
        variableName: selectedData + "." + selectOption?.value,
        variable: id,
        data_type:
          selectedDataType === "multi_signers" ||
          selectedDataType === "digital_stamp"
            ? selectedDataType
            : "image",
      })
    );
    dispatch(updateCoordinate({ id, newValue }));
  };

  useEffect(() => {
    setDragBoxDetails(currVariable);
  }, [currVariable]);

  return (
    <Wrapper>
      <div style={{ ...selectStyle }}>
        <Select
          defaultValue={{ value: items?.value, label: items?.value }}
          autoFocus={true}
          options={options}
          onChange={handleSelectOnChange}
          styles={customStyles}
          menuIsOpen={menuOpen}
          onFocus={() => setMenuOpen(true)} 
          onBlur={() => setMenuOpen(false)}
        />

        {/* {currVariable?.fontSpace > 1 && (
          <div
            style={{
              letterSpacing: currVariable?.fontSpace,
              fontSize: currVariable?.fontSize,
              textAlign: "center",
              padding: 6,
            }}
          >
            {currVariable?.variableName}
          </div>
        )} */}
      </div>

      {(subSelectData?.length > 0 || splitData) && (
        <div style={{ ...Style }}>
          <Select
            defaultValue={{ value: splitData, label: splitData }}
            autoFocus={true}
            options={subSelectData}
            onChange={handleChangeSubSelect}
            styles={customStyles}
          />
        </div>
      )}
      {/* {currVariable?.data_type === "text" && ( */}
      <div style={{ ...StyleFontBox, display: "flex" }}>
        <ToolBar
          settedFontSize={settedFontSize}
          settedFontSpace={settedFontSpace}
          settedBoxHeight={settedBoxHeight}
          settedBoxWidth={settedBoxWidth}
          currVariable={currVariable}
          coordinate={items}
          setSelectedBoxId={setSelectedBoxId}
        />
        {/* <FontSizeHover settedFontSize={settedFontSize} /> */}{" "}
        {/* Dont use them*/}
        {/* <FontSpacingHover />  */} {/* Dont use them*/}
      </div>
      {/* )} */}
    </Wrapper>
  );
};

export default SelectField;

const Wrapper = styled.div`
  .css-1nmdiq5-menu {
    width: 200px !important;
  }
  display: flex;
`;
